import snippetSchema from './snippet';

const emailSnippet = snippetSchema('emailSnippets');

export default emailSnippet;